export default __webpack_public_path__ + "locales/sr-Latn-RS/ChangeUserTypeDialog.json?hash=23d42a01d672a8b627a807c1ed7dd62b";